
import GLightbox from "glightbox";
import $ from "jquery";


$(function() {

    let st = 0;
    let carouselImages = $('img.carousel-image');
    let animating = false;
    let animatingOpacityIn = false;
    let animatingOpacityOut = false;
    let navbar = $('header nav.navbar');
    let navbarContainer = $('header nav.navbar > div.container');
    let navbarHeight = $(navbar).outerHeight(true);
    //let navarStartPos = $(navbar).position().top;
    let navarStartPos = $('header').height();
    let header = $('div.header');
    let menuToggle = $('div.menu-toggle');
    let navMobile = $('nav.nav-mobile');
    let isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    let currentScrollPos = 0;
    let htmlbody = $('html, body');

    GLightbox({
        touchNavigation: true,
        loop: true,
    });

    $.fn.initialize = function () {
        st = $(window).scrollTop();
        $.fn.toggleNavbar();
    };

    $.fn.ScrollDown = function () {

        animating = true;
        let newScrollPos = Math.ceil($(navbar).position().top) + 1;

        if(st < newScrollPos) {

            if(isMobile) {
                $('body').animate({
                    scrollTop: newScrollPos
                }, 1000, function () {
                    animating = false;
                });
            }
            else {
                $(htmlbody).animate({
                    scrollTop: newScrollPos
                }, 1000, function () {
                    animating = false;
                });
            }

        }

    };

    $.fn.toggleNavbar = function() {

        if(st >= (navarStartPos-navbarHeight)) {
            $(navbar).addClass('fixed-top');
            $('main').css('padding-top', navbarHeight);

            if($(header).is(':visible')) {
                let headerHeight = $(header).height();


                if(isMobile) {
                    $(header).addClass('d-none');
                    $('body').animate({
                        scrollTop: 0
                    }, 10);
                    /*
                    $(header).hide(5, function () {
                        $('body').scrollTop(0);
                    });
                    */
                }
                else {
                    let time = 0;
                    if(window.navigator.userAgent.indexOf("Chrome") > -1) {
                        time = 5;
                    }
                    $(header).hide(time, function () {
                        $(htmlbody).scrollTop(0);
                    });
                }
                /*
                if(window.navigator.userAgent.indexOf("Chrome") > -1 || isMobile) {
                    $(header).hide(300, function () {
                        $('html, body').scrollTop(0);
                    });
                }
                else {
                    $(header).hide(0, function () {
                        $('html, body').scrollTop(0);
                    });
                }
                */
            }
        }
        else {
            /*
            $(navbar).removeClass('fixed-top');
            $('main').css('padding-top', 0);
            */
        }


        if(st >= navarStartPos - ($(window).height()/2)) {
            if(!animatingOpacityIn) {
                animatingOpacityIn = true;
                $(navbarContainer).stop().animate({opacity: 1}, 300, function () {
                    animatingOpacityIn = false;
                    animatingOpacityOut = false;
                    $(navbar).css('pointer-events', 'auto');
                });
            }



        }
        else {
            /*
            if(!animatingOpacityOut) {
                animatingOpacityOut = true;
                $(navbarContainer).stop().animate({opacity: 0}, 300, function () {
                    animatingOpacityOut = false;
                    animatingOpacityIn = false;
                    $(navbar).css('pointer-events', 'none');
                });
            }
            */
        }



    };

    $('i.down').on('click', function () {

        $.fn.ScrollDown();

    });

    $('a.navbar-brand').on('click', function (e) {
        e.preventDefault();
        if (!animating) {
            $('html, body').animate({
                //scrollTop: navarStartPos-navbarHeight
                scrollTop: 0
            }, 1000, function () {
                animating = false;
            });
        }
    });

    $(window).scroll(function (event) {
        $.fn.initialize();
    });

    $(window).resize(function () {
        navarStartPos = $('header').height();
        $.fn.initialize();
    });

    $(carouselImages).on("load", function () {
        let url = this.currentSrc;
        if (url === undefined) {
            url = $(this).attr('src');
        }
        $(this).parent().parent().css('background-image', 'url(' + url + ')');
    });

    $(carouselImages).each(function () {

        if ($(this).parent().parent().css('background-image') === 'none') {
            let url = this.currentSrc;

            if (url === undefined) {
                url = $(this).attr('src');
            }
            $(this).parent().parent().css('background-image', 'url(' + url + ')');
        }

    });

    if($('div.header').length === 0) {
        $(navbarContainer).css('opacity', 1);
        $(navbar).css('pointer-events', 'auto');
    }

    $(menuToggle).click(function () {


        $(navMobile).css('padding-top', $(navbar).outerHeight(true));
        $(navMobile).css('padding-bottom', $(navbar).outerHeight(true));
        let iconDefault = $(this).find('i.icon-default');
        let iconDefault2 = $(this).find('i.icon-default2');
        let iconHover = $(this).find('i.icon-hover');

        $(iconDefault).toggleClass('click');
        $(iconDefault2).toggleClass('click');
        $(iconHover).toggleClass('click');


        if($(iconDefault).hasClass('click')) {

            if(isMobile) {
                currentScrollPos = $('body').scrollTop();
            }
            else {
                currentScrollPos = $(htmlbody).scrollTop();
            }

            $(navMobile).slideDown(300, function() {
                $('html, body').css('position', 'fixed');
            });
        }
        else {
            $(htmlbody).css('position', 'relative');
            if(isMobile) {
                $('body').scrollTop(currentScrollPos);
            }
            else {
                $('html, body').scrollTop(currentScrollPos);
            }
            $(navMobile).slideUp(300, function() {
            });
        }

    });



    $.fn.initialize();

});